import Vue from 'vue'
import Router from 'vue-router'
import index from "../views/index/index"
import login from "../views/login/login";
import ResetPasswd from "../views/login/reset-passwd";
import decision from "../views/decision/decision"
import malfunction from "@/views/malfunction/malfunction";
import malfunctionMech from "@/views/malfunction/malfunctionMech";
import task from "@/views/task/task"
import assessment from "@/views/assessment/assessment";
import eventinitiation from "@/views/eventinitiation/eventinitiation";
import backlog from "@/views/backlog/backlog"
import bumpprevention from "@/views/bumpprevention/bumpprevention"
import Commitanalogdata from "@/views/Commitanalogdata/Commitanalogdata"
import simulator from "@/views/simulator/simulator"
import simulator2 from "@/views/simulator2/simulator2"
import eventinitiationSIM from "@/views/eventinitiation/eventinitiationSIM.vue";
import CabinEvent from "@/views/Eventhandling/CabinEvent";
import risksource from "@/views/risksource/risksource"
import DevicePlayer from "@/components/player/DevicePlayer.vue";

import largescreen from "@/views/largescreen/largescreen"
import { userCurrent } from "@/api/api";
import store from "@/store";
//数据大屏
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        // 首页
        {
          path: '/index',
          name: 'home',
          component: index,
          meta: {
            isToken: true,
          }
        }
      ]
    },
    // 登陆
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // 重置密码
    {
      path: '/reset-passwd',
      name: 'ResetPasswd',
      component: ResetPasswd
    },
    // 地面运行起飞前故障决策
    {
      path: '/decision',
      name: 'decision',
      component: decision
    },
    // 故障信息
    {
      path: '/malfunction/:id',
      name: 'malfunction',
      component: malfunction
    },
    // 故障信息
    {
      path: '/malfunctionMech/:id',
      name: 'malfunctionMech',
      component: malfunctionMech
    },
    // 任务
    {
      path: '/task/:client',
      name: 'task',
      component: task
    },
    // 风险评估
    {
      path: '/assessment',
      name: 'assessment',
      component: assessment
    },
    // 飞行故障风险评估：进行中列表
    {
      path: '/eventinitiation',
      name: 'eventinitiation',
      component: eventinitiation
    },
    //飞行故障风险评估：模拟机处理状态
    {
      path: '/simulator/:id',
      name: 'simulator',
      component: simulator
    },
    //飞行故障风险评估：结果页面
    {
      path: '/Commitanalogdata/:id',
      name: 'Commitanalogdata',
      component: Commitanalogdata
    },
    // 事件发起
    {
      path: '/eventinitiationSIM',
      name: 'eventinitiationSIM',
      component: eventinitiationSIM
    },
    // 协同处置
    {
      path: '/backlog',
      name: 'backlog',
      component: backlog
    },
    // 颠簸危害预防
    {
      path: '/bumpprevention',
      name: 'bumpprevention',
      component: bumpprevention
    },
    //模拟机数据处理
    {
      path: '/simulator2/:id',
      name: 'simulator2',
      component: simulator2
    },
    //空防客仓扰乱事件处置系统
    {
      path: '/CabinEvent/:client/:id',
      name: 'CabinEvent',
      component: CabinEvent
    },
    //空防客仓扰乱事件处置系统
    {
      path: '/risksource/:client',
      name: 'risksource',
      component: risksource
    },
    {
      path: '/device-player/:device',
      name: 'DevicePlayer',
      component: DevicePlayer
    },
    {
      path: '/largescreen',
      name: 'largescreen',
      component: largescreen
    },

  ]
})

/*进入路由之前*/
router.beforeEach(async(to, from, next) => {
  let loginInfo = window.localStorage.getItem('currentUser')//用户信息
  let token = window.localStorage.getItem('x-token')//用户token
  //console.log('islogin', islogin)
  /*判断是否需要token*/
  if (to.meta.isToken) {
    if (token == null) {
      console.log('没有token,被拦截')
      return next("/login")
    }
    try {
      if (loginInfo == null) {
        const user = await userCurrent();
        if (user.code === "A00000") {
          localStorage.setItem("currentUser", JSON.stringify(user.data[0]));
          store.commit("setCurrentUser", user.data[0]);
        } else {
          return next("/login");
        }
      }
    } catch (e) {
      console.error(e)
      return next("/login");
    }
    next()
  } else {
    if (to.path === '/') {
      // 重定向到首页
      return next("/largescreen")
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js